import { useCallback, useEffect, useState } from "react";

import {
  type DashboardAdminUser,
  invalidateAllSessionsForAuserAsAdmin,
  listPlatformUsersAsAdmin,
} from "../dashboard-client";

interface UseAdminUsersState {
  users: DashboardAdminUser[];
  loading: boolean;
  error: string | null;
}

export function useAdminUsers() {
  const [state, setState] = useState<UseAdminUsersState>({
    error: null,
    loading: false,
    users: [],
  });

  const refresh = useCallback(async () => {
    setState((s) => ({ ...s, error: null, loading: true }));
    try {
      const { data } = await listPlatformUsersAsAdmin({});
      setState({ error: null, loading: false, users: data.users });
    } catch (error) {
      setState((s) => ({
        ...s,
        error: error instanceof Error ? error.message : "Failed to load users",
        loading: false,
      }));
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const invalidateSessions = useCallback(
    async (userId: string) => {
      await invalidateAllSessionsForAuserAsAdmin({ path: { userId } });
      await refresh();
    },
    [refresh],
  );

  return {
    error: state.error,
    invalidateSessions,
    loading: state.loading,
    refresh,
    users: state.users,
  };
}
